import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  Col,
  Typography,
  Avatar,
  Spin,
  message,
  Tag,
} from 'antd';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  CalendarOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { apiClient } from '../../../config/apiClient';
import MainLayout from '../../layout/layout';

const { Text, Title } = Typography;

const JugadorMisDatos = () => {
  const [loading, setLoading] = useState(true);
  const [jugador, setJugador] = useState(null);

  useEffect(() => {
    const cargarPerfil = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get('/club/mi/perfil');
        if (!response.ok) {
          const error = await response.json();
          message.error(error.message || 'No se pudieron cargar tus datos');
          return;
        }
        const data = await response.json();
        setJugador(data);
      } catch (error) {
        console.error('Error cargando perfil de jugador:', error);
        message.error('No se pudieron cargar tus datos');
      } finally {
        setLoading(false);
      }
    };
    cargarPerfil();
  }, []);

  const infoItem = (label, value, icon) => (
    <Card size="small" style={{ height: '100%' }}>
      <Text type="secondary" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {icon}
        {label}
      </Text>
      <div style={{ marginTop: 8 }}>
        <Text>{value || 'No registrado'}</Text>
      </div>
    </Card>
  );

  return (
    <MainLayout>
      <div style={{ maxWidth: 980, margin: '0 auto' }}>
        <Title level={3} style={{ marginBottom: 20 }}>
          Mis datos
        </Title>
        <Spin spinning={loading}>
          {jugador && (
            <Card>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                  marginBottom: 20,
                  flexWrap: 'wrap',
                }}
              >
                <Avatar
                  size={96}
                  src={jugador.jcl_foto || null}
                  icon={!jugador.jcl_foto ? <UserOutlined /> : null}
                />
                <div>
                  <Title level={4} style={{ margin: 0 }}>
                    {jugador.jcl_nombre} {jugador.jcl_apellido}
                  </Title>
                  <Tag style={{ marginTop: 8 }} color="blue">
                    Jugador
                  </Tag>
                </div>
              </div>

              <Row gutter={[12, 12]}>
                <Col xs={24} md={12}>
                  {infoItem('Nombre', jugador.jcl_nombre, <UserOutlined />)}
                </Col>
                <Col xs={24} md={12}>
                  {infoItem('Apellido', jugador.jcl_apellido, <UserOutlined />)}
                </Col>
                <Col xs={24} md={12}>
                  {infoItem('Email', jugador.jcl_email, <MailOutlined />)}
                </Col>
                <Col xs={24} md={12}>
                  {infoItem('Teléfono', jugador.jcl_telefono, <PhoneOutlined />)}
                </Col>
                <Col xs={24} md={12}>
                  {infoItem(
                    'Fecha de nacimiento',
                    jugador.jcl_nacimiento ? dayjs(jugador.jcl_nacimiento).format('DD/MM/YYYY') : null,
                    <CalendarOutlined />
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {infoItem('Sexo', jugador.jcl_sexo, <TeamOutlined />)}
                </Col>
                <Col xs={24}>
                  {infoItem('Categoría', jugador.categoria_nombre, <TeamOutlined />)}
                </Col>
              </Row>
            </Card>
          )}
        </Spin>
      </div>
    </MainLayout>
  );
};

export default JugadorMisDatos;
